import { apiClient } from './api';

export interface CcgGroup {
  id: number;
  name: string;
  ownerCustomerId: number;
  maxMembers: number;
  status: string;
  createdAt: string;
  updatedAt: string;
  closedAt?: string;
}

export interface CcgMember {
  id: number;
  groupId: number;
  customerId: number;
  status: string;
  joinMethod: string;
  joinedAt: string;
  leftAt?: string;
}

export interface CcgInvite {
  id: number;
  groupId: number;
  inviteePhone: string;
  inviteeCustomerId?: number;
  status: string;
  messageText: string;
  in24hWindow: boolean;
  createdAt: string;
  sentAt?: string;
  respondedAt?: string;
  expiresAt?: string;
}

export const ccgService = {
  async getGroupsByCustomer(customerId: number): Promise<CcgGroup[]> {
    const response = await apiClient.get(`/ccg/customer/${customerId}/groups`);
    return response.data;
  },

  async getGroupById(groupId: number): Promise<CcgGroup> {
    const response = await apiClient.get(`/ccg/groups/${groupId}`);
    return response.data;
  },

  async getGroupMembers(groupId: number): Promise<number[]> {
    const response = await apiClient.get(`/ccg/groups/${groupId}/members`);
    return response.data;
  },

  async createGroup(ownerCustomerId: number, name: string): Promise<CcgGroup> {
    const response = await apiClient.post('/ccg/groups', { ownerCustomerId, name });
    return response.data;
  },

  async createInvite(
    groupId: number,
    inviteePhone: string,
    messageText: string,
    in24hWindow: boolean
  ): Promise<CcgInvite> {
    const response = await apiClient.post('/ccg/invites', {
      groupId,
      inviteePhone,
      messageText,
      in24hWindow,
    });
    return response.data;
  },

  async acceptInvite(inviteId: number, customerId: number): Promise<void> {
    await apiClient.post(`/ccg/invites/${inviteId}/accept`, { customerId });
  },

  async declineInvite(inviteId: number): Promise<void> {
    await apiClient.post(`/ccg/invites/${inviteId}/decline`);
  },

  async leaveGroup(groupId: number, customerId: number): Promise<void> {
    await apiClient.post(`/ccg/groups/${groupId}/leave`, { customerId });
  },
};
